import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import {
  backMsg,
  orderSubmittedForProcessingMsg,
  returnToCustomerViewMsg,
  salesFormsEntryReminderMsg,
  t,
} from '../../../common/i18n/index.js';
import { OpenFormBar } from '../OpenFormComponents/OpenFormBar.js';
import { OpenFormButton } from '../OpenFormComponents/OpenFormButton.js';
import { OpenFormGridBlock, OpenFormGridCol, OpenFormGridRow } from '../OpenFormComponents/OpenFormGrid.js';
import { OpenFormIcon } from '../OpenFormComponents/OpenFormIcon.js';
import { type OpenFormGotoProps, useOpenFormGoto } from '../OpenFormHooks/useOpenFormGoto.js';
import { useOpenFormAsync } from '../OpenFormProvider.js';
import { isIframe } from '../OpenFormUtils.js';

export const OpenFormThankYou = () => {
  const { list = paths.OPENFORM_LIST_FORM } = (useLocation().state ?? {}) as OpenFormGotoProps;
  const async = useOpenFormAsync();
  const goto = useOpenFormGoto();

  useEffect(() => async.store.removeItem(async.state.form?.reference as string), [async]);

  return (
    <OpenFormBar leftFunc={() => goto({ list })} leftIcon="arrow-left" leftText={t.D1E9(backMsg)}>
      <OpenFormGridBlock justifyCenterOuter={true}>
        <OpenFormGridCol colWidth={8} className="of-openform__thank-you__container">
          <h2 className="of-openform__thank-you__h2">{t.SOQ1(orderSubmittedForProcessingMsg)}</h2>
          <div className="of-openform__thank-you__paragraph-container">
            <OpenFormGridRow className="of-openform__thank-you__paragraph-row" justifyCenter={false}>
              <OpenFormIcon size="m" icon="information" type="regular" className="of-openform__thank-you__check" />
              <span>{t.LDN7(salesFormsEntryReminderMsg)}</span>
            </OpenFormGridRow>
          </div>
          <OpenFormGridRow className="of-openform__thank-you__picture ds-margin-vertical--4"></OpenFormGridRow>
          {!isIframe() ? null : (
            <OpenFormButton
              className="of-openform__view__thank-you--button"
              color="primary"
              text={t.OW3C(returnToCustomerViewMsg)}
              icon={<OpenFormIcon icon="check" />}
              size="l"
              disabled={false}
              onClick={() => async.frame.postMessageRedirectToAccount()}
            />
          )}
        </OpenFormGridCol>
      </OpenFormGridBlock>
    </OpenFormBar>
  );
};
